import { styled } from 'stitches.config'
import { Collapsible } from 'components/Collapsible'

const InformationHeader = styled(Collapsible.Trigger, {
  border: 'none',
  borderRadius: '0px',
  fontSize: '$bodyExtraLarge',
  justifyContent: 'center',
  color: '$accent-black',
  cursor: 'pointer',
  position: 'relative',
})

const InformationContent = styled(Collapsible.Content, {
  color: '$accent-black',
  textAlign: 'center',
  fontSize: '$body',
  padding: '0px 8px 24px 8px',

  '@bp3': {
    fontSize: '$bodyLarge',
  },
})

const InformationRoot = styled(Collapsible.Root, {
  borderTop: '3px solid $primary-700',

  '&:last-child ': {
    borderBottom: '3px solid $primary-700',
  },

  variants: {
    v2: {
      true: {
        '& > button': {
          justifyContent: 'flex-start',
          fontSize: '$h5',
          fontFamily: '$display',
          padding: '20px 38px 18px 8px',
          textAlign: 'left',
        },

        borderTop: '1px solid $accent-gray',

        '& > div': {
          textAlign: 'left',
        },

        '&:first-child': {
          borderTop: '2px solid $accent-black',
          paddingTop: '$1',
        },

        '&:last-child': {
          borderBottom: '1px solid $accent-gray',
        },

        '@bp3': {
          '& > button': {
            fontSize: '$h3',
          },
        },
      },
    },
  },

  
})

export const Information = {
  Root: InformationRoot,
  Trigger: InformationHeader,
  Content: InformationContent,
}

export const Ingredients = styled('span', {
  fontSize: '$caption',
  '@bp3': {
    fontSize: '$small',
  },
})

export const InformationWrapper = styled('div', {
  width: '100%',
  margin: '52px 0px 52px 0px',
  paddingRight: '8px',
  paddingLeft: '8px',

  '@bp3': {
    margin: 'auto',
    marginTop: '56px',
    marginBottom: '16px',
    maxWidth: '800px',
    paddingRight: 0,
    paddingLeft: 0,
  },

  variants: {
    v2: {
      true: {
        paddingRight: 0,
        paddingLeft: 0,
        marginTop: '$3',
        marginBottom: 0,

        '@bp3': {
          marginTop: '42px',
          marginBottom: 0,
        },
      },
    },
  },
})

export const IconWrapper = styled('div', {
  position: 'absolute',
  right: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& svg': {
    transition: 'transform 0.3s ease',
  },

  '& .rotate': {
    transform: 'rotate(180deg)',
  },
})

export const Compliant = styled('span', {
  fontStyle: 'italic',
  display: 'block',
  margin: 'auto',
  width: '100%',
  maxWidth: '360px',

  '@bp3': {
    maxWidth: '560px',
  },
})
